module.exports = __webpack_public_path__ + "img/businessCooperation-pc.0d1abc6.png";